import React from "react";
import PortfolioImg1 from "../../Assets/Portfolio/applab.jpg";
import PortfolioImg2 from "../../Assets/Portfolio/icraft.jpg";
import PortfolioImg3 from "../../Assets/Portfolio/KhudaLagche.jpg";
import PortfolioImg4 from "../../Assets/Portfolio/dipeyecare.jpg";
import PortfolioImg5 from "../../Assets/Portfolio/Foodball.jpg";
import PortfolioImg6 from "../../Assets/Portfolio/noobcoders.jpg";
import "./Portfolio.css";

const Portfolio = () => {
  return (
    <section className="portfolio container" id="portfolio">
      <div data-aos="fade-down" data-aos-duration="2000">
        <h1 class="heading">
      
          my <span>portfolio</span>
        </h1>
      </div>

      <div class="box-container">
        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="photo">
              <img src={PortfolioImg1} alt="Zaeem Al Farabi" />
            </div>

            <div class="about">
              <h2>App Lab</h2>
              <p>AppLab is a app development company landing page.</p>
            </div>

            <div class="button">
              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://github.com/jahidulislamzim/applab"
                rel="noreferrer"
              >
                <i class="fa-brands fa-github"></i> GitHub Repo
              </a>

              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://appslab.netlify.app/"
                rel="noreferrer"
              >
                <i class="fa-solid fa-browser"></i> Live Site
              </a>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="photo">
              <img src={PortfolioImg2} alt="Zaeem Al Farabi" />
            </div>

            <div class="about">
              <h2>iCraft</h2>
              <p>
                this website has 6 services it has login form and register form
                Order ,Delete , Price services are available in website.
              </p>
            </div>

            <div class="button">
              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://github.com/jahidulislamzim/icraft-client"
                rel="noreferrer"
              >
                <i class="fa-brands fa-github"></i> GitHub Repo
              </a>

              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://handy-craft.netlify.app/home"
                rel="noreferrer"
              >
                <i class="fa-solid fa-browser"></i> Live Site
              </a>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="photo">
              <img src={PortfolioImg3} alt="Zaeem Al Farabi" />
            </div>

            <div class="about">
              <h2>Khuda Lagche</h2>
              <p>
                Khuda Lagche is an food delivery website. it's make using React
                Js, Node Js, Express Js, MongoDB.
              </p>
            </div>

            <div class="button">
              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://github.com/jahidulislamzim/KhudaLagche-client"
                rel="noreferrer"
              >
                <i class="fa-brands fa-github"></i> GitHub Repo
              </a>

              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://khuda-lagche.netlify.app/"
                rel="noreferrer"
              >
                <i class="fa-solid fa-browser"></i> Live Site
              </a>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="photo">
              <img src={PortfolioImg4} alt="Zaeem Al Farabi" />
            </div>

            <div class="about">
              <h2>Dip Eye Care</h2>
              <p>
                Patient Care, Hopital Service, Surgery Pakages services are
                available
              </p>
            </div>

            <div class="button">
              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://github.com/jahidulislamzim/dipEyeCare"
                rel="noreferrer"
              >
                <i class="fa-brands fa-github"></i> GitHub Repo
              </a>

              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://dip-eye-care.netlify.app/"
                rel="noreferrer"
              >
                <i class="fa-solid fa-browser"></i> Live Site
              </a>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="photo">
              <img src={PortfolioImg5} alt="Zaeem Al Farabi" />
            </div>

            <div class="about">
              <h2>FoodBall Forever</h2>
              <p>
                Get the latest live football scores, results & fixtures from
                across the world, including Premier League
              </p>
            </div>

            <div class="button">
              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://github.com/jahidulislamzim/football-forever"
                rel="noreferrer"
              >
                <i class="fa-brands fa-github"></i> GitHub Repo
              </a>

              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://assignment-02-zim.netlify.app/"
                rel="noreferrer"
              >
                <i class="fa-solid fa-browser"></i> Live Site
              </a>
            </div>
          </div>
        </div>

        <div
          data-aos="zoom-in-up"
          data-aos-duration="2000"
          data-aos-anchor-placement="center-bottom"
        >
          <div class="card">
            <div class="photo">
              <img src={PortfolioImg6} alt="Zaeem Al Farabi" />
            </div>

            <div class="about">
              <h2>Noob Coders</h2>
              <p>
                When we started NoobCoders, our goal was to give anyone in the
                world the ability to learn the skills they’d need to succeed in
                the 21st century
              </p>
            </div>

            <div class="button">
              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://github.com/jahidulislamzim/Noobcoder"
                rel="noreferrer"
              >
                <i class="fa-brands fa-github"></i> GitHub Repo
              </a>

              <a
                type="button"
                target="_blank"
                class="innerbtn"
                href="https://education-assignment.netlify.app/"
                rel="noreferrer"
              >
                <i class="fa-solid fa-browser"></i> Live Site
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
